import { Component, ComponentInterface, h, Prop, Element } from '@stencil/core';
import isEmpty from 'lodash/isEmpty';
import {
	modesOfOpening,
	ModesOfOpening,
} from '../../../../_storybook-helpers/ctaControls';
import { calculateChildTagName } from '../_helpers/prefixes';

@Component({
	tag: 'ds-pull-quote',
})
export class PullQuote implements ComponentInterface {
	@Prop() name: string; // mandatory
	@Prop() quote: string; // mandatory
	@Prop() alignment: 'left' | 'center' = 'left';
	@Prop() jobTitle = '';
	@Prop() image = '';
	@Prop() altText = '';
	@Prop() isNested = false; // isNested = false = block behaviour | isNested = true = nested behaviour
	@Prop() ctaLabel = '';
	@Prop() ctaUrl = '';
	@Prop() ctaLinkTitle = '';
	@Prop() ctaMode = '';
	@Prop() ctaAriaLabel = '';
	@Prop() dataLinkEvent = '';
	@Prop() hideBottomPadding = false;
	@Prop() hideTopPadding = false;
	@Prop() authorNameLink = '';
	@Prop() authorLinkOpeningMode: ModesOfOpening =
		modesOfOpening['Current Window'];

	@Element() el: HTMLDsPullQuoteElement;

	renderCta() {
		const Button = calculateChildTagName(this.el, 'ds-button');

		return (
			<Button
				is-link="true"
				type="secondary"
				color=""
				target={this.ctaMode}
				href={this.ctaUrl}
				title={this.ctaLinkTitle}
				aria-label={this.ctaAriaLabel}
				data-link-event={this.dataLinkEvent}
			>
				{this.ctaLabel}
				<i class="fa fa-chevron-right" aria-hidden="true"></i>
			</Button>
		);
	}

	render() {
		const alignment = isEmpty(this.image) ? 'left' : this.alignment; // always left alignment when no image
		const cssAlignment = `ds-pull-quote-alignment-${alignment}`;
		const cssNoImage = isEmpty(this.image) ? 'ds-pull-quote-no-image' : '';
		let cssContent = `ds-pull-quote-content row ${
			this.isNested ? 'ds-pull-quote-nested' : ''
		}`;

		if (this.hideTopPadding) {
			cssContent += ' ds-no-top-padding';
		}

		if (this.hideBottomPadding) {
			cssContent += ' ds-no-bottom-padding';
		}

		// no CTA when nested component
		const showCta =
			!this.isNested &&
			typeof this.ctaLabel === 'string' &&
			this.ctaLabel !== '' &&
			typeof this.ctaUrl === 'string' &&
			this.ctaUrl !== '';

		return (
			<div class={`${cssContent} ${cssAlignment} ${cssNoImage}`}>
				{this.image !== '' && !this.isNested && (
					<div class="col ds-col ds-pull-quote-left-col">
						<img
							src={this.image}
							alt={this.altText}
							title={this.name}
							class="ds-pull-quote-mb"
						/>
					</div>
				)}
				<div class="col ds-col ds-pull-quote-right-col">
					<i class="fas fa-quote-left"></i>
					<div
						class="ds-body-l-bold ds-pull-quote-text"
						innerHTML={this.quote}
					/>
					<div class="ds-pull-quote-author-info">
						<div class="ds-body-m-bold ds-pull-quote-author-indentation">
							<hr class="ds-separator-line" />
						</div>
						{this.image !== '' && this.isNested && (
							<div class="ds-pull-quote-image-nested">
								<img src={this.image} alt={this.altText} title={this.name} />
							</div>
						)}
						<div>
							{this.authorNameLink !== '' ? (
								<div class="ds-body-m-bold">
									<a
										class="ds-author-name-link"
										href={this.authorNameLink}
										target={this.authorLinkOpeningMode}
									>
										{this.name}
									</a>
								</div>
							) : (
								<div class="ds-body-m-bold">{this.name}</div>
							)}
							{this.jobTitle !== '' && (
								<div class="ds-body-m">{this.jobTitle}</div>
							)}
						</div>
					</div>
					{showCta && this.renderCta()}
				</div>
			</div>
		);
	}
}
